import React from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { Dropdown } from "react-bootstrap";
import { FaComment, FaEnvelope, FaFileCsv, FaFilePdf, FaFileExcel } from "react-icons/fa";


const ActionButton = ({ rowSelection, filteredPatients, columns }) => {
    const navigate = useNavigate();

    const handleExportCSV = () => {
        if (!rowSelection || Object.keys(rowSelection).length === 0) {
            alert("No patients selected.");
            return;
        }

        const selectedPatients = Object.keys(rowSelection)
            .map(rowId => filteredPatients.find((patient, index) => index === parseInt(rowId)))
            .filter(patient => patient !== undefined);

        if (selectedPatients.length === 0) {
            alert("No selected patients could be found.");
            return;
        }

        selectedPatients.forEach(patient => {
            const patientName = patient.name || "patient";
            exportToCSV([patient], patientName);
        });
    };

    const exportToCSV = (patients, patientName) => {
        if (!patients || patients.length === 0) {
            alert("No patients selected.");
            return;
        }

        const headers = Object.keys(patients[0]).join(',');

        const rows = patients.map(p =>
            Object.values(p).map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        const csv = `${headers}\n${rows}`;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        const fileName = `${patientName}.csv`;
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    {/*}  const exportToPDF = () => {
        if (!rowSelection || Object.keys(rowSelection).length === 0) {
            alert("No hay pacientes seleccionados.");
            return;
        }

        const selectedPatients = Object.keys(rowSelection)
            .map(rowId => filteredPatients.find((patient, index) => index === parseInt(rowId)))
            .filter(patient => patient !== undefined);

        if (selectedPatients.length === 0) {
            alert("No se pudieron encontrar pacientes seleccionados.");
            return;
        }

        const patientName = selectedPatients.length === 1
            ? selectedPatients[0].name
            : "varios_pacientes";

        const doc = new jsPDF();

        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: selectedPatients.map(p =>
                columns.map(col => p[col.accessorKey])
            ),
            theme: 'grid',
            margin: { top: 10 },
        });

        doc.save(`${patientName}.pdf`);
    };*/}

    const handleExportExcel = () => {
        if (!rowSelection || Object.keys(rowSelection).length === 0) {
            alert("No patients selected.");
            return;
        }

        const selectedPatients = Object.keys(rowSelection)
            .map(rowId => filteredPatients.find((patient, index) => index === parseInt(rowId)))
            .filter(patient => patient !== undefined);

        if (selectedPatients.length === 0) {
            alert("No se pudieron encontrar pacientes seleccionados.");
            return;
        }

        selectedPatients.forEach(patient => {
            const patientName = patient.name || "patient";
            exportToExcel([patient], patientName);
        });
    };

    const exportToExcel = (patients, patientName) => {
        if (!patients || patients.length === 0) {
            alert("No patients selected.");
            return;
        }

        const sheetData = patients.map(patient => {
            return Object.values(patient);
        });

        const headers = Object.keys(patients[0]);

        const ws = XLSX.utils.aoa_to_sheet([headers, ...sheetData]);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Patient");

        const fileName = `${patientName}.xlsx`;

        XLSX.writeFile(wb, fileName);
    };
    const handleActionClick = (action) => {
        if (action === "Send Mail") {
            navigate("/mail");
        }

        if (action === "Send Chat") {
            navigate("/message");
        }

        if (action === "Export CSV") {
            handleExportCSV();
        }

        if (action === "Export PDF") {
            {/*}  exportToPDF();*/}
        }

        if (action === "Export Excel") {
            handleExportExcel();
        }
    };

    

    
    return (
        <div className="flex-grow-sm-0">
            <Dropdown>
                <Dropdown.Toggle
                    id="action-dropdown"
                    className={`btn btn-gray text-start w-100 d-flex align-items-center justify-content-between px-4 py-2 border-0 rounded-3 shadow-sm dropdownbtn`}
                    
                >
                    <span>Action</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-3 shadow-sm mt-2">
                    <Dropdown.Item
                        onClick={() => handleActionClick("Send Mail")}
                        className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                        <FaEnvelope className="icon-sm" />
                        <span>Send Mail</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => handleActionClick("Send Chat")}
                        className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                        <FaComment className="icon-sm" />
                        <span>Send Message</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => handleActionClick("Export CSV")}
                        className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                        <FaFileCsv className="icon-sm" />
                        <span>Download CSV</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => handleActionClick("Export PDF")}
                        className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                        <FaFilePdf className="icon-sm" />
                        <span>Download PDF</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => handleActionClick("Export Excel")}
                        className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                        <FaFileExcel className="icon-sm" />
                        <span>Download Excel</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default ActionButton;